import { RecordingDialogContentProps } from '@smart-tv/components/dialog/recording-dialog';

export enum NpvrTab {
  Storage = 'storage',
  Recordings = 'recordings',
  Expiring = 'expiring',
  Planned = 'planned',
  Errors = 'errors'
}

export interface NpvrTabProps {
  setDialogProps: (dialogProps: RecordingDialogContentProps | null) => void;
}

export const getNPVRTabFocusKey = (tab: NpvrTab) => `npvr-tab-${tab}`;

export const getNPVRCardFocusKey = (index: number) => `npvr-card-${index}`;

export const getNPVRActionFocusKey = (index: number) => `npvr-card-${index}-action`;
